import targetTypes from '../constants/target-types';
import { targetClasses } from '../constants/target-classes';

const getTargetType = (key) =>
  Object.values(targetClasses).includes(key) ? targetTypes.CLASS : targetTypes.ATTRIBUTE;

export default getTargetType;
